import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/pipelines/sources/journeys',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
